import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "contexts";
import { PaginatedItems, PaginatedListQuery } from "types/api";
import { PointsShopItem } from "types/points-shop";
import { buildQueryParam, buildQueryParams } from "utils/api/api-utils";
export const useGetPointShopListKey = "/point-shop/items-list";

interface GetPointShopListParams extends PaginatedListQuery {
  sort?: string;
  favoriteOnly?: boolean;
}

export function useGetPointShopList({
  skip,
  take,
  search,
  sort,
  favoriteOnly,
}: GetPointShopListParams) {
  const { apiService } = useAppContext();

  return useQuery<PaginatedItems<PointsShopItem>>({
    queryKey: [useGetPointShopListKey, skip, take, search, sort, favoriteOnly],
    queryFn: async () => {
      const skipParam = buildQueryParam("skip", skip);
      const takeParam = buildQueryParam("take", take);
      const searchParam = buildQueryParam("search", search);
      const favoriteOnlyParam = buildQueryParam("favoriteOnly", favoriteOnly);

      const sortValue = sort && sort !== "order:asc" ? `${sort}:desc` : sort;
      const sortParam = buildQueryParam("sort", sortValue);

      const queryParams = buildQueryParams([
        skipParam,
        takeParam,
        searchParam,
        sortParam,
        favoriteOnlyParam,
      ]);

      const response = await apiService.get<PaginatedItems<PointsShopItem>>(
        `/point-shop/items${queryParams}`
      );
      return response;
    },
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
}
